import React from 'react';

import { logChangesRenderer } from 'redux/modules/log/log-changes';

const defaultRenderer = ({ changes = {} }) => {
  return changes && !!Object.keys(changes).length && <pre>{JSON.stringify(changes, null, 2)}</pre>;
};

const Changes = ({ action, shipperOrderId, ...props }) => {
  const render = logChangesRenderer[action]
    ? logChangesRenderer[action]({ action, shipperOrderId, ...props })
    : defaultRenderer({ action, ...props });
  return render;
};

export default Changes;
